import { useEffect, useState } from "react";
import { FlaskConical, Loader2 } from "lucide-react";
import api from "@/api";

const ROLE_ICON_COLOR = {
  SUPER_ADMIN_SAAS: "bg-slate-800",
  ADMIN_CLINIQUE: "bg-indigo-600",
  MEDECIN: "bg-primary",
  IDE: "bg-teal-600",
  SECRETAIRE_MEDICAL: "bg-amber-600",
  PATIENT: "bg-rose-500",
};

export function DemoAccessPanel({ onDemoLogin, disabled }) {
  const [profiles, setProfiles] = useState(null);
  const [busyKey, setBusyKey] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/demo-accounts", { skipAuth: true })
      .then((res) => { if (!cancelled) setProfiles(res.data?.profiles || []); })
      .catch(() => { if (!cancelled) setProfiles([]); });
    return () => { cancelled = true; };
  }, []);

  if (!profiles || profiles.length === 0) return null;

  const handleClick = async (key) => {
    setBusyKey(key);
    try { await onDemoLogin(key); } finally { setBusyKey(null); }
  };

  return (
    <div data-testid="demo-access-panel" className="mb-6 rounded-2xl border border-dashed border-amber-300 bg-amber-50/70 p-4">
      <div className="flex items-center gap-2 mb-3">
        <FlaskConical className="w-4 h-4 text-amber-700" strokeWidth={2} />
        <p className="text-xs font-bold uppercase tracking-wide text-amber-800" data-testid="demo-access-title">
          Accès démo Preview — données fictives
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {profiles.map((p) => (
          <button
            key={p.key}
            type="button"
            disabled={disabled || busyKey !== null}
            onClick={() => handleClick(p.key)}
            data-testid={`demo-login-${p.key}`}
            className="flex items-center gap-2 rounded-xl bg-white border border-amber-200 px-3 py-2.5 text-left text-sm font-semibold text-slate-700 shadow-sm transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-amber-100/60 disabled:opacity-60 disabled:hover:translate-y-0"
          >
            <span className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${ROLE_ICON_COLOR[p.role] || "bg-slate-400"}`} />
            <span className="flex-1 truncate">{p.label}</span>
            {busyKey === p.key && <Loader2 className="w-4 h-4 animate-spin text-amber-700" />}
          </button>
        ))}
      </div>
    </div>
  );
}
